import { Field } from "formik";

import { PasswordShow, PasswordView } from "../../icons";

const PasswordField = ({ name, placeholder, isVisible, toggleVisibility, errors, touched }) => (
  <div className="form-group input-with-icon password-icon">
    {isVisible ? (
      <PasswordView className="cursor-pointer" onClick={toggleVisibility} />
    ) : (
      <PasswordShow className="cursor-pointer" onClick={toggleVisibility} />
    )}
    <Field
      className={touched[name] && errors[name] ? "error form-control" : "form-control"}
      type={isVisible ? "text" : "password"}
      name={name}
      placeholder={placeholder}
    />
    {touched[name] && errors[name] && <div className="invalid-feedback">{errors[name]}</div>}
  </div>
);

export default PasswordField;
